var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTriangleDown = function SvgTriangleDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 4,
    viewBox: "0 0 6 4"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#636463"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 3.5H1L3 .833 5 3.5z",
    transform: "rotate(180 3 2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 1.667L2 3h2L3 1.667M3 0l3 4H0l3-4z",
    transform: "rotate(180 3 2)"
  }))));
};
export { SvgTriangleDown as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2IiBoZWlnaHQ9IjQiIHZpZXdCb3g9IjAgMCA2IDQiPgogICAgPGcgZmlsbD0iIzYzNjQ2MyI+CiAgICAgICAgPHBhdGggZD0iTTUgMy41SDFMMyAuODMzIDUgMy41eiIgdHJhbnNmb3JtPSJyb3RhdGUoMTgwIDMgMikiLz4KICAgICAgICA8cGF0aCBkPSJNMyAxLjY2N0wyIDNoMkwzIDEuNjY3TTMgMGwzIDRIMGwzLTR6IiB0cmFuc2Zvcm09InJvdGF0ZSgxODAgMyAyKSIvPgogICAgPC9nPgo8L3N2Zz4K";